<mat-paginator [length]="length" [class]="displayClass" [pageSize]="pageSize" [pageIndex]="pageIndex"
 [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)"
    aria-label="Select page" [showFirstLastButtons]="showFirstLastButtons">
</mat-paginator>